import { VacationStatusEnum } from "domain/enum/vacationStatus";
import { SupportTripStatusEnum } from "domain/enum/supportTripStatus";
import { ExpenseStatusEnum } from "domain/enum/expenseStatus";
import { InvoiceStatusEnum } from "domain/enum/invoiceStatus";
import { TimesheetStatusEnum } from "domain/enum/timesheetStatus";

export const ALL_STATUSES_KEY = "all";

export interface StatusFilterOption {
    key: string;
    label: string;
    // Statuses covered by this tab; when omitted, the tab covers only its own key
    statuses?: string[];
}

export const VACATION_STATUS_FILTERS: StatusFilterOption[] = [
    { key: VacationStatusEnum.A_APROVAR, label: "A Aprovar" },
    { key: VacationStatusEnum.APROVADO, label: "Aprovado" },
    { key: VacationStatusEnum.NAO_APROVADO, label: "Não Aprovado" },
    { key: VacationStatusEnum.CANCELAMENTO_PENDENTE, label: "Canc. Pendente" },
    { key: VacationStatusEnum.CANCELADO, label: "Cancelado" },
];

export const SUPPORT_TRIP_STATUS_FILTERS: StatusFilterOption[] = [
    { key: SupportTripStatusEnum.A_APROVAR, label: "A Aprovar" },
    { key: SupportTripStatusEnum.APROVADO, label: "Aprovado" },
    { key: SupportTripStatusEnum.NAO_APROVADO, label: "Não Aprovado" },
    { key: SupportTripStatusEnum.CANCELAMENTO_PENDENTE, label: "Canc. Pendente" },
    { key: SupportTripStatusEnum.CANCELADO, label: "Cancelado" },
];

export const EXPENSE_STATUS_FILTERS: StatusFilterOption[] = [
    { key: ExpenseStatusEnum.PENDENTE, label: "Pendente" },
    { key: ExpenseStatusEnum.APROVADO, label: "Aprovado" },
    { key: ExpenseStatusEnum.NAO_APROVADO, label: "Não Aprovado" },
    { key: ExpenseStatusEnum.PAGO, label: "Pago" },
];

export const INVOICE_STATUS_FILTERS: StatusFilterOption[] = [
    { key: InvoiceStatusEnum.ENVIADO, label: "Enviado" },
    { key: InvoiceStatusEnum.APROVADO, label: "Aprovado" },
    { key: InvoiceStatusEnum.NAO_APROVADO, label: "Não Aprovado" },
];

/* Timesheets never reach "Aprovado"/"Não Aprovado",
  and "Novo"/"Editado" both mean "not submitted yet" for the employee */
export const TIMESHEET_STATUS_FILTERS: StatusFilterOption[] = [
    {
        key: "novo-editado",
        label: "Novo/Editado",
        statuses: [TimesheetStatusEnum.NOVO, TimesheetStatusEnum.EDITADO],
    },
    { key: TimesheetStatusEnum.ENVIADO, label: "Enviado" },
    { key: TimesheetStatusEnum.CANCELADO, label: "Cancelado" },
];

